import {NeoModal} from "@/components/@modal/neo.modal";
import {NeoTextBox} from "@/components/forms";
import {NeoError} from "@/components/shared";
import {routePlanService} from "@/service/routePlan.service";
import {yupResolver} from "@hookform/resolvers/yup";
import {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import Select from "react-select";
import * as yup from "yup";

type EditInfowindowProps = {
  variantId: number;
  sourceRoute: RouteDetails_RP;
  bpData: UserBoarding_RP;
  variantRoute: any;
  currentVariant: any;
  setCurrentVariant: any;
  closePopup: any;
  refreshSingleRoute: any;
};
interface FormValues {
  bpId: number;
  name: string;
  latitude: string;
  longitude: string;
  routeId: number | null;
}
const schema: yup.ObjectSchema<FormValues> = yup.object({
  bpId: yup.number().required(),
  name: yup.string().nullable().required(),
  latitude: yup.string().nullable().required(),
  longitude: yup.string().nullable().required(),
  routeId: yup.number().required("Designation Route is mandatory")
});
export const EditBpwindow = function ({
  variantId,
  sourceRoute,
  bpData,
  variantRoute,
  currentVariant,
  setCurrentVariant,
  closePopup,
  refreshSingleRoute
}: EditInfowindowProps) {
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [request, setRequest] = useState<FormValues | {}>({});
  const [processingPopupmodal, setProcessingPopupmodal] = useState(false);
  const [oldCurrentVariantId, setOldCurrentVariantId] = useState<number | null>(
    null
  );
  const [errorMessage, setErrorMessage] = useState<any>(null);

  const {
    register,
    handleSubmit,
    control,
    getValues,
    setError,
    setValue,
    reset,
    formState: {errors, isSubmitting}
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      bpId: bpData?.id,
      name: bpData?.name,
      latitude: String(bpData?.latitude) ?? "",
      longitude: String(bpData?.longitude) ?? "",
      routeId: null
    }
  });

  useEffect(() => {
    if (oldCurrentVariantId && oldCurrentVariantId !== 0) {
      handlePopupModal();
    }
  }, [oldCurrentVariantId]);
  useEffect(() => {
    if (Object.prototype.hasOwnProperty.call(request, "routeId")) {
      setConfirmPopup(true);
    }
  }, [request]);
  const handlePopupModal = () => {
    setProcessingPopupmodal(true);
  };

  const onSubmit = (data: FormValues) => {
    setRequest(data);
  };
  // when enable confirmation popup remove  requestData params and directly get request from state
  const editBp = async (optionType: string) => {
    setConfirmPopup(false);
    //option1 -> Add Boarding Point Only,option2 -> Add Boarding Point and Replan Route
    //need to change requestData to request variable name when enable confirmation popup
    const routeId = "routeId" in request ? request.routeId : null;
    const req = {
      ...request,
      sRoute: sourceRoute.id,
      dRoute: routeId,
      operation: 2, //edit operation
      rType: 1, // route optimize or old neotrack route
      reRoute: optionType === "option1" ? 0 : 2,
      routePlanVariantId: currentVariant
    };
    await routePlanService
      .bpOperations(req)
      .then(async (response: any) => {
        //console.log("Response", response);
        if (response?.status === "success") {
          setOldCurrentVariantId(currentVariant);
          setConfirmPopup(false);
          setCurrentVariant(0); //to trigger the useEffect in variant map and fetch new current variant
          reset();
        } else {
          setErrorMessage("Insufficient credit points.");
        }
      })
      .catch(err => {
        if (err?.errors?.length > 0) {
          err?.errors?.forEach(
            ({field, message}: {field: any; message: string}) => {
              setError(field, {type: "server", message: message});
            }
          );
        }
      })
      .finally(() => {
        //setLoading(false);
        setTimeout(() => {
          setErrorMessage(null);
        }, 2000);
      });
  };
  const changeVariant = () => {
    const routeId = "routeId" in request ? request.routeId : null;
    if (routeId) {
      refreshSingleRoute(routeId);
    }
    if (sourceRoute.id) {
      refreshSingleRoute(sourceRoute.id as number);
    }
    closePopup();
    setCurrentVariant(oldCurrentVariantId);
    setOldCurrentVariantId(0);
  };
  return (
    <>
      <div className="w-full rounded-xl p-1 shadow-sm ring-1 ring-black/5 md:p-1">
        <section className="w-full rounded-lg border border-gray-200 bg-gray-50 p-4">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col gap-2"
          >
            <div className="flex w-full flex-col items-start gap-2">
              <div className="flex w-full flex-col justify-between gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs">
                <p className="text-gray-500">Source Route</p>
                <p className="max-w-[60%] truncate font-semibold text-gray-900">
                  {sourceRoute.name ?? "N/A"}
                </p>
              </div>
              <div className="flex w-full">
                <Controller
                  name="routeId"
                  control={control}
                  render={({field, fieldState}) => (
                    <div className="flex flex-col gap-1">
                      <label
                        // style={style.label}
                        id="aria-label"
                        htmlFor="aria-example-input"
                        className="text-xs"
                      >
                        Destination Route
                      </label>
                      <Select
                        name="routeId"
                        className="w-full"
                        options={
                          sourceRoute?.id
                            ? (variantRoute ?? []).filter(
                                (e: any) => e.routeId !== sourceRoute.id
                              )
                            : (variantRoute ?? [])
                        }
                        getOptionLabel={(e: any) => e.routeName}
                        getOptionValue={e => e.routeId.toString()}
                        // defaultValue={variantRoutesData.find(
                        //   opt => opt.routeId === defaultVehicleSingle
                        // )}
                        value={
                          field.value
                            ? (variantRoute?.find(
                                (o: any) =>
                                  String(o.routeId) === String(field.value)
                              ) ?? null)
                            : null
                        }
                        onChange={selectedOption => {
                          field.onChange(
                            selectedOption
                              ? String(selectedOption.routeId)
                              : null
                          );
                        }}
                        placeholder="Select Route"
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            width: "320px",
                            minHeight: "30px",
                            // padding: "3px",
                            borderWidth: "2px",
                            borderColor: "#d4d4d8",
                            borderRadius: "16px",
                            paddingLeft: "6px",
                            paddingRight: "6px",
                            boxShadow: "none",
                            fontSize: "13px",
                            color: "#000",
                            // fontWight: "bold",
                            backgroundColor: "white",
                            "&:hover": {
                              borderColor: "#d4d4d8"
                            }
                          }),
                          placeholder: base => ({
                            ...base,
                            color: "#6b7280",
                            fontSize: "14px"
                          }),
                          indicatorSeparator: () => ({
                            display: "none"
                          }),
                          dropdownIndicator: base => ({
                            ...base,
                            color: "#6b7280",
                            paddingRight: "8px"
                          }),
                          // singleValue: base => ({
                          //   ...base,
                          //   color: "#111827"
                          // }),
                          menu: base => ({
                            ...base,
                            borderRadius: "10px",
                            zIndex: 50
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isFocused
                              ? "#e5e7eb"
                              : "white",
                            color: "#111827",
                            padding: "10px 12px",
                            cursor: "pointer",
                            borderRadius: "8px",
                            margin: "2px 4px"
                          })
                        }}
                      />
                      {fieldState.error && (
                        <p className="mt-1 text-xs text-pink-600">
                          {fieldState.error.message}
                        </p>
                      )}
                    </div>
                  )}
                />
              </div>
              <div className="flex w-full items-center justify-between gap-2">
                {/* <input type="hidden" {...register("bpId")} /> */}
                <Controller
                  name="name"
                  control={control}
                  render={({field}) => (
                    <NeoTextBox
                      {...field}
                      label="Stop Name"
                      placeholder="Name"
                      id="name"
                      size="sm"
                      color={errors.name ? "danger" : "default"}
                      isInvalid={errors.name ? true : false}
                      errorMessage={errors.name && `${errors.name.message}`}
                      autoComplete="off"
                      {...register("name")}
                      onChange={e => {
                        field.onChange(e);
                        //  msgreplaceword(e);
                      }}
                    />
                  )}
                />
              </div>
              <div className="hidden items-center justify-between gap-2">
                <Controller
                  name="latitude"
                  control={control}
                  render={({field}) => (
                    <NeoTextBox
                      {...field}
                      label="Latitude"
                      placeholder="Lat"
                      id="lat"
                      size="sm"
                      color={errors.latitude ? "danger" : "default"}
                      isInvalid={errors.latitude ? true : false}
                      errorMessage={
                        errors.latitude && `${errors.latitude.message}`
                      }
                      autoComplete="off"
                      {...register("latitude")}
                      onChange={e => {
                        field.onChange(e);
                        //  msgreplaceword(e);
                      }}
                    />
                  )}
                />
                <Controller
                  name="longitude"
                  control={control}
                  render={({field}) => (
                    <NeoTextBox
                      {...field}
                      label="Latitude"
                      placeholder="Lng"
                      id="lng"
                      size="sm"
                      color={errors.longitude ? "danger" : "default"}
                      isInvalid={errors.longitude ? true : false}
                      errorMessage={
                        errors.longitude && `${errors.longitude.message}`
                      }
                      autoComplete="off"
                      {...register("longitude")}
                      onChange={e => {
                        field.onChange(e);
                        //  msgreplaceword(e);
                      }}
                    />
                  )}
                />
              </div>
              {/* <div className="flex w-full items-center justify-end">
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    searchInputLoaction();
                  }}
                  className="float-end text-xs text-blue-600 underline hover:text-blue-800"
                >
                  Search Input Location
                </a>
              </div> */}
              {errorMessage ? (
                <NeoError message={errorMessage}></NeoError>
              ) : null}
              <div className="mb-2 mt-2 flex w-full items-center justify-end gap-2">
                <button
                  type="submit"
                  className="rounded-lg bg-black px-4 py-1 text-sm font-medium text-white hover:bg-gray-800"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </section>
      </div>
      <NeoModal
        actionType={"boardingConformation"}
        onOpen={confirmPopup}
        onClose={() => setConfirmPopup(false)}
        hasActions={false}
        data={{
          message: {
            title: "Edit Boarding Point And Replan Route",
            options: {
              // option1: {
              //   subTitle: "Edit Boarding Point Only",
              //   content:
              //     "Edit this Boarding Point from the route. The current route will remain unchanged."
              // },
              option2: {
                subTitle: "Edit Boarding Point And Replan Route",
                content:
                  "Edit this Boarding Point and re-optimize the route to adding this stop, improving the route for the remaining boarding points."
              }
            }
          },
          onConfirm: editBp,
          reqData: {sourceRoute, ...request}
        }}
      ></NeoModal>
      <NeoModal
        actionType={"routePlanProcessingPopup"}
        onOpen={processingPopupmodal}
        onClose={() => setProcessingPopupmodal(false)}
        hasActions={false}
        data={{
          changeVariant,
          newAddedVariantId: oldCurrentVariantId,
          type: "addBP"
        }}
      ></NeoModal>
    </>
  );
};
